import { TouchableOpacity, View } from 'react-native';
import React, { useState } from 'react';
import type { SvgProps } from 'react-native-svg';
import { Text } from '~/components';
import QuestionSVG from '~/assets/svgs/question.svg';
import Item from './components/Item';
import { Controller, type Control } from 'react-hook-form';
import HelpModal from './components/HelpModal';

interface Props {
  icon: React.FC<SvgProps>;
  title: string;
  description: string;
  name: string;
  control: Control<any, any>;
}

const Service = ({ icon: Icon, title, description, name, control }: Props) => {
  const [showHelp, setShowHelp] = useState<boolean>(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <View className="pb-5 border-b border-b-gray-100">
          <View className="flex-row justify-between items-center flex-1 mb-2 mt-5">
            <View className="flex-row items-center">
              <Icon />
              <Text className="ml-2 font-medium text-gray-600">{title}</Text>
            </View>

            <TouchableOpacity
              activeOpacity={0.6}
              hitSlop={{ top: 8, right: 8, bottom: 8, left: 8 }}
              onPress={() => setShowHelp(true)}
            >
              <QuestionSVG />
            </TouchableOpacity>
          </View>

          <View className="flex-row justify-between space-x-2">
            <View className="flex-1">
              <Item importance="low" current={value} onPress={onChange} />
            </View>

            <View className="flex-1">
              <Item importance="important" current={value} onPress={onChange} />
            </View>
          </View>

          <View className="flex-row justify-between space-x-2">
            <View className="flex-1">
              <Item
                importance="very_important"
                current={value}
                onPress={onChange}
              />
            </View>

            <View className="flex-1">
              <Item importance="necessary" current={value} onPress={onChange} />
            </View>
          </View>

          <HelpModal
            title={title}
            description={description}
            icon={Icon}
            visible={showHelp}
            onDismiss={() => setShowHelp(false)}
          />
        </View>
      )}
    />
  );
};

export default Service;
